const _ = require('underscore');

_.mixin({
    sleep: function(duration) {
        return new Promise(resolve => setTimeout(resolve, duration));
    },
    loop: function(callback, interval, duration) {
        let i = interval;
        while (i < duration) {
            _.delay(callback, i);
            i += interval;
        }
        return _.sleep(duration);
    },
    when: function(condition, callback, interval) {
        let i = setInterval(() => {
            if (condition()) {
                clearInterval(i);
                if(callback()) {
                    _.when(condition, callback, interval);
                }
            }
        }, interval || 100);
    }
});

module.exports = _;